import { useQuery } from '@tanstack/react-query';
import { HcpSwitchoverApi } from '../../../apis/HcpSwitchoverApi/HcpSwitchoverApi.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

export const useGetHcpSwitchoverLegacyHcps = () =>
    useQuery({
        queryKey: [QueryKeys.hcpSwitchoverLegacyHcps],
        queryFn: () => HcpSwitchoverApi.getLegacyHcps(),
    });
